import { resolveColivingImageUrl } from './colivingImageUrl'

/**
 * URL de imagen optimizada para tarjetas de listado (LCP / ancho de banda).
 * Usa listImageUrl del API si existe; si no, deriva del original.
 */
export function toColivingListImageUrl(imageUrl) {
  if (!imageUrl || typeof imageUrl !== 'string') return ''
  const url = imageUrl.trim()
  if (!url) return ''

  if (url.includes('images.unsplash.com') || url.includes('unsplash.com')) {
    try {
      const parsed = new URL(url)
      parsed.searchParams.set('w', '480')
      parsed.searchParams.set('q', '75')
      parsed.searchParams.set('fm', 'webp')
      return parsed.toString()
    } catch {
      return url
    }
  }

  if (url.includes('res.cloudinary.com') && url.includes('/upload/')) {
    return url.replace('/upload/', '/upload/w_480,f_auto,q_auto/')
  }

  // Blueground: no transformar — q_auto:eco,w_480 rompe URLs sweetinn/partner-network (404).
  if (url.includes('theblueground.com')) {
    return url
  }

  if (url.includes('imgix.net') || url.includes('imgix.com')) {
    try {
      const parsed = new URL(url)
      parsed.searchParams.set('w', '480')
      parsed.searchParams.set('auto', 'format,compress')
      return parsed.toString()
    } catch {
      return url
    }
  }

  if (url.includes('wp.com') || url.includes('wordpress.com')) {
    try {
      const parsed = new URL(url)
      parsed.searchParams.set('w', '480')
      return parsed.toString()
    } catch {
      return url
    }
  }

  return url
}

/** listImageUrl del API puede traer q_auto:eco,w_480 (404 en sweetinn) hasta redeploy backend. */
function pickBluegroundImageUrl(imageUrl, listImageUrlFromApi) {
  const original = (imageUrl || '').trim()
  const list = (listImageUrlFromApi || '').trim()
  if (!list) return original
  if (!list.includes('theblueground.com')) return list
  if (list.includes('q_auto:eco') || /q_auto,w_(?!1920)\d+/.test(list)) {
    return original || list
  }
  return list
}

export function getColivingListImageUrl(imageUrl, listImageUrlFromApi = '') {
  const raw = pickBluegroundImageUrl(imageUrl, listImageUrlFromApi)
  if (!raw) return ''
  const resolved = resolveColivingImageUrl(raw)
  return toColivingListImageUrl(resolved)
}
